import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Capacitor } from '@capacitor/core';
import { PushService } from 'src/app/services/push.service';
import { TranslateModule } from '@ngx-translate/core';
import { NgIf } from '@angular/common';
import { LoaderComponent } from '../../../components/loader/loader.component';
import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonToolbar,
} from '@ionic/angular/standalone';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.page.html',
  standalone: true,
  imports: [
    IonContent,
    LoaderComponent,
    NgIf,
    TranslateModule,
    IonHeader,
    IonToolbar,
    IonButtons,
    IonButton,
  ],
})
export class NotificationsPage implements OnInit {
  loading: boolean = true;
  enabling: boolean = false;

  constructor(private router: Router, private pushService: PushService) {}

  ngOnInit() {
    if (Capacitor.isNativePlatform()) {
      this.checkStatus();
    } else {
      this.skip(true);
    }
  }

  async checkStatus() {
    this.enabling = true;
    let enabled = await this.pushService.isOSPushEnabled();
    if (enabled) {
      this.pushService.enablePush();
      this.skip(true);
    } else {
      this.loading = false;
    }
    this.enabling = false;
  }

  async allowPush() {
    this.enabling = true;
    await this.pushService.requestPermission();
    this.skip();
    this.enabling = false;
  }

  async skip(replaceUrl: boolean = false) {
    await this.router.navigate(['onboarding', 'address', 'create'], {
      replaceUrl: replaceUrl,
    });

    if (!replaceUrl) {
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    }
  }
}
